export default __webpack_public_path__ + "static/shooting-seckelmann-eaceb6b5b5f10886d9a218ea0eb295d4.jpg";